import styled from "styled-components";

import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";
import { businessDashboardTabOptions } from "constants/businessDashboard";
import type { DashboardUIType } from "types/BusinessDashboard";

const Container = styled.div`
  width: 100%;
  padding: 0 24px;
  background-color: transparent;
`;

const TabNavWrapper = styled.nav`
  display: flex;
  align-items: center;
  gap: 4px;
  background: #d1dbf04d;
  border-radius: 24px;
  padding: 0 4px;
  height: 46px;
  min-height: 46px;
  position: relative;
  box-sizing: border-box;

  @media (max-width: 320px) {
    height: 44px;
    min-height: 44px;
    border-radius: 22px;
  }
`;

const TabButton = styled.button<{ active: boolean }>`
  flex: 1 1 0%;
  height: 38px;
  border: none;
  outline: none;
  border-radius: 20px;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0%;
  font-weight: ${({ active }) => (active ? 700 : 600)};
  color: ${({ active }) => (active ? "#004FEC" : "#fff")};
  background: ${({ active }) => (active ? "#fff" : "transparent")};
  transition:
    background 0.25s,
    color 0.25s,
    font-weight 0.25s;
  cursor: pointer;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  @media (max-width: 320px) {
    font-size: 14px;
    height: 36px;
    border-radius: 18px;
  }
`;

export function DashboardTabNavigation() {
  const { searchParams, updateUrlParams } = useUpdateUrlParams();
  const currentTab = (searchParams.get("view") ??
    "realtime") as DashboardUIType;

  const handleTab = (view: DashboardUIType) => {
    updateUrlParams({
      view,
      tab: "",
      month: "",
      innerTab: "",
      innerMembersTab: "",
    });
  };

  return (
    <Container>
      <TabNavWrapper>
        {businessDashboardTabOptions.map((tab) => (
          <TabButton
            key={tab.id}
            active={currentTab === tab.id}
            onClick={() => handleTab(tab.id)}
            type="button"
          >
            {tab.label}
          </TabButton>
        ))}
      </TabNavWrapper>
    </Container>
  );
}
